import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';

export interface BottomControlModel {
	isDisplay?: boolean;
}

export class BottomMobileService {
	missionAnnouncedSource = new Subject<string>();
	// Observable string streams
	missionAnnounced$ = this.missionAnnouncedSource.asObservable();
	// Service message commands

	isDisplay = new BehaviorSubject(true);
	bottomSubject = new ReplaySubject<BottomControlModel>(1);

	constructor() {}

	announceMission(mission: string) {
		this.missionAnnouncedSource.next(mission);
	}

	onChange(display: boolean) {
		this.isDisplay.next(display);
	}
}
